import produce from 'immer';
import { SET_CURRENT_FEEDBACK } from 'src/actions/feedbackActions';

/* eslint-disable no-param-reassign */
type Action = {
  payload: any;
  type: string;
};

type InitialState = {
  feedback: string | null;
  type: 'error' | 'success';
};

const initialState: InitialState = {
  feedback: null,
  type: 'error',
};

const feedbackReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CURRENT_FEEDBACK: {
      const { feedback, type } = action.payload;

      return produce(state, (draft) => {
        draft.feedback = feedback;
        draft.type = type;
      });
    }

    default: {
      return state;
    }
  }
};

export default feedbackReducer;
